var map = {
	"./claims/claims.module": [
		"./src/app/features/claims/claims.module.ts",
		"claims-claims-module~client-client-module~employee-employee-module~settings-settings-module",
		"common",
		"claims-claims-module"
	],
	"./client/client.module": [
		"./src/app/features/client/client.module.ts",
		"claims-claims-module~client-client-module~employee-employee-module~settings-settings-module",
		"common",
		"client-client-module"
	],
	"./dashboard/analytics/analytics.module": [
		"./src/app/features/dashboard/analytics/analytics.module.ts",
		"dashboard-analytics-analytics-module"
	],
	"./employee/employee.module": [
		"./src/app/features/employee/employee.module.ts",
		"claims-claims-module~client-client-module~employee-employee-module~settings-settings-module",
		"common",
		"employee-employee-module"
	],
	"./forgot/forgot.module": [
		"./src/app/features/auth/forgot/forgot.module.ts",
		"forgot-forgot-module"
	],
	"./locked/locked.module": [
		"./src/app/features/auth/locked/locked.module.ts",
		"common",
		"locked-locked-module"
	],
	"./login/login.module": [
		"./src/app/features/auth/login/login.module.ts",
		"common",
		"login-login-module"
	],
	"./maps/maps.module": [
		"./src/app/features/maps/maps.module.ts",
		"common",
		"maps-maps-module"
	],
	"./register/register.module": [
		"./src/app/features/auth/register/register.module.ts",
		"register-register-module"
	],
	"./settings/settings.module": [
		"./src/app/features/settings/settings.module.ts",
		"claims-claims-module~client-client-module~employee-employee-module~settings-settings-module",
		"common",
		"settings-settings-module"
	],
	"app/features/auth/auth.module": [
		"./src/app/features/auth/auth.module.ts",
		"app-features-auth-auth-module"
	],
	"app/features/medius.module": [
		"./src/app/features/medius.module.ts",
		"app-features-medius-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;